<template lang="pug">
.custom-progress.onSurface-bg(:style="{ height: _height }")
  pr-badge.custom-label(v-show="label", :style="{ left: _diff_width }") {{ label }}
  .custom-value.primary-bg(:style="{ width: _width }")
  .custom-diff.primary-bg(:style="{ width: _diff_width }")
</template>

<script>
export default {
  name: "progress-bar",
  props: ["value", "height", "diff", "label"],
  computed: {
    _width() {
      return (this.value > 100 ? 100 : this.value < 0 ? 0 : this.value || 0) + "%"
    },
    _diff_width() {
      return (this.diff || 0) + "%"
    },
    _height() {
      return (this.height || 5) + "px"
    }
  }
}
</script>

<style lang="scss">
.custom-progress {
  position: relative;

  .custom-value,
  .custom-diff {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
  }

  .custom-label {
    position: absolute;
    z-index: 3;
    transform: translate(-50%, -150%);
  }
  .custom-value {
    z-index: 2;
  }
  .custom-diff {
    z-index: 1;
    opacity: 0.5;
  }
}
</style>
